
<template>
  <div>
    <base-card>
      <template slot="title">
        {{ $tc('done', 2)}}
      </template>

      <template v-slot:content>
        <div v-if="!loading && projects.length">
          <project-small-card v-for="project in projects" :key="project.id" :project="project"></project-small-card>
        </div>
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <div v-if="!loading && !projects.length">
          {{ $t('projects.none') }}
        </div>
      </template>
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'ProjectsDoing',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      projects: [],
    }
  },
  methods: {
    getProjects() {
      this.loading = true
      Api.Project.index({status: ['done', 'canceled']}).then(r=> r.data).then(d => {
        this.projects = [...d]
      }).finally(()=> {
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getProjects()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    '$route'(nv,ov) {
      // console.log({ov, nv});
      if (['NewProject'].includes(ov.name)){
        this.getProjects()
      }
    }
  },
}
</script>

<style scoped>

</style>